import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["imageable_id_input",
        "imageable_type_input",
        "file_input",
        "preview_container",
        "title",
        "description"]

    declare readonly imageable_type_inputTarget: HTMLInputElement
    declare readonly imageable_id_inputTarget: HTMLInputElement
    declare readonly titleTarget: HTMLInputElement
    declare readonly file_inputTarget: HTMLInputElement
    declare readonly preview_containerTarget: HTMLDivElement
    declare readonly descriptionTarget: HTMLTextAreaElement

    open(event: any) {
        const {id, type} = event.detail;
        (this.element as HTMLDialogElement).showModal();
        this.imageable_type_inputTarget.value = type;
        this.imageable_id_inputTarget.value = id;
        this.resetForm()
    }

    resetForm() {
        this.file_inputTarget.value = "";
        this.preview_containerTarget.classList.add("hidden");
        this.titleTarget.value = "";
        this.descriptionTarget.value = "";
    }

    close() {
        const dialog = this.element as HTMLDialogElement
        dialog.close()
    }
}
